import React from 'react';

export const DEFAULT_HERO_IMAGE = 'https://images.unsplash.com/photo-1651499910684-b6b82c2da504?w=1920';

/** 0 = mörkast overlay, 100 = ljusast — samma som admin Utseende */
export function computeHeroOverlayStyle(rawBrightness) {
  const b = Math.min(
    100,
    Math.max(
      0,
      Number(
        rawBrightness !== undefined && rawBrightness !== null && !Number.isNaN(Number(rawBrightness))
          ? rawBrightness
          : 10,
      ),
    ),
  );
  const darken = (100 - b) / 100;
  const aTop = 0.05 + darken * 0.7;
  const aMid = 0.08 + darken * 0.77;
  const aBot = 0.12 + darken * 0.83;
  return {
    background: `linear-gradient(180deg, rgba(11, 30, 51, ${aTop}) 0%, rgba(11, 30, 51, ${aMid}) 50%, rgba(11, 30, 51, ${aBot}) 100%)`,
  };
}

export function computeHeroBgStyle(heroBgImage, backgroundAlignX, backgroundAlignY) {
  const img = heroBgImage || DEFAULT_HERO_IMAGE;
  const ax = backgroundAlignX;
  const ay = backgroundAlignY;
  const x = ['left', 'center', 'right'].includes(ax) ? ax : 'center';
  const y = ['top', 'center', 'bottom'].includes(ay) ? ay : 'center';
  return {
    backgroundImage: `url(${img})`,
    backgroundSize: 'cover',
    backgroundPosition: `${x} ${y}`,
    backgroundRepeat: 'no-repeat',
  };
}

/** CMS-värden: default | white | orange | blue — blå = ByggFynd marinblå (#003B73), samma som t.ex. Admin-knappar */
export function getHeroSubtitleStyle(subtitleColor) {
  const c = subtitleColor || 'default';
  if (c === 'default') return undefined;
  const map = {
    white: { color: 'rgba(255, 255, 255, 0.95)' },
    orange: { color: '#F97316' },
    blue: { color: '#003B73' },
  };
  return map[c] || undefined;
}

function titleWordColorClass(color) {
  if (color === 'orange') return 'text-[#F97316]';
  if (color === 'blue') return 'text-[#003B73]';
  return 'text-white';
}

export function renderColoredTitle(title, coloredWords = []) {
  if (!coloredWords || coloredWords.length === 0) {
    return title;
  }

  const sortedWords = coloredWords
    .filter((cw) => cw.word && title.includes(cw.word))
    .sort((a, b) => title.indexOf(a.word) - title.indexOf(b.word));

  const parts = [];
  let lastIndex = 0;

  for (const coloredWord of sortedWords) {
    const index = title.indexOf(coloredWord.word, lastIndex);
    if (index !== -1) {
      if (index > lastIndex) {
        parts.push(<span key={`text-${lastIndex}`}>{title.substring(lastIndex, index)}</span>);
      }
      const colorClass = titleWordColorClass(coloredWord.color);
      parts.push(
        <span key={`colored-${index}`} className={colorClass}>
          {coloredWord.word}
        </span>,
      );
      lastIndex = index + coloredWord.word.length;
    }
  }

  if (lastIndex < title.length) {
    parts.push(<span key="text-end">{title.substring(lastIndex)}</span>);
  }

  return parts.length > 0 ? parts : title;
}
